/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iaW5oZXJpdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjcxIDIuMDAwMDFMMTQgMS4yOTAwMUw3Ljk5OTk4IDcuMjkwMDFMMS45OTk5OCAxLjI5MDAxTDEuMjg5OTggMi4wMDAwMUw3LjI4OTk4IDguMDAwMDFMMS4yODk5OCAxNEwxLjk5OTk4IDE0LjcxTDcuOTk5OTggOC43MTAwMUwxNCAxNC43MUwxNC43MSAxNEw4LjcwOTk4IDguMDAwMDFMMTQuNzEgMi4wMDAwMVoiIGZpbGw9ImluaGVyaXQiLz4=";